import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=4b532c71&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=4b532c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b532c71",
  null
  
)

export default component.exports